import Badge from '@/src/components/atom/Badge';
import Button from '@/src/components/atom/Button';
import Dialog from '@/src/components/atom/Dialog';
import SectionLabel from '@/src/components/molecule/SectionLabel';
import { BUTTON_CONST } from '@/src/constants/buttons';
import { PartnershipCompainesDto } from '@/src/models/PartnershipCompainesDto';

interface PartnershipCompaniesDetailModalProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  onOkClick: () => void;
  data?: PartnershipCompainesDto;
}

const PartnershipCompaniesDetailModal = ({
  open: openProps,
  onOpenChange: onOpenChangeProps,
  onOkClick,
  data,
}: PartnershipCompaniesDetailModalProps) => {
  const handleCloseModal = () => {
    onOpenChangeProps(false);
  };

  const renderFooter = () => {
    return (
      <div className="flex justify-end gap-2">
        <Button
          className="flex-1"
          buttonColor="outline"
          onClick={handleCloseModal}
        >
          {BUTTON_CONST.close}
        </Button>
        <Button className="flex-1" onClick={onOkClick}>
          {BUTTON_CONST.editShort}
        </Button>
      </div>
    );
  };

  return data ? (
    <Dialog
      open={openProps}
      onOpenChange={handleCloseModal}
      contentProps={{
        style: {
          width: 'calc(100vw - 24px)',
        },
        className: 'max-w-[697px]',
      }}
      title="제휴사 정보 상세"
      footer={renderFooter()}
    >
      <div className="flex flex-col gap-6">
        <SectionLabel label="제휴사 명" value={data.name} />
        <SectionLabel label="대표 전화번호" value={data.phone} />
        <SectionLabel label="대표 이메일" value={data.email || '-'} />
        <SectionLabel label="홈페이지 링크" value={data.homepageUrl || '-'} />
        <SectionLabel
          label="사용 여부"
          value={
            <Badge badgeColor={data.isUsing ? 'lightGreen' : 'lightGray'}>
              {data.isUsing ? '사용' : '미사용'}
            </Badge>
          }
        />
      </div>
    </Dialog>
  ) : null;
};

export default PartnershipCompaniesDetailModal;
